export const getApiData='https://api.webalytics.checkbrand.companydemo.in/api/sites';
export const getDashData='https://api.webalytics.checkbrand.companydemo.in/api/sites/insights/';
export const token=localStorage.getItem('token');